import {defineStore} from 'pinia';

let localUserData = localStorage.getItem('userData');
if (localUserData) {
    try {
        localUserData = JSON.parse(localUserData);
    } catch (error) {
        localUserData = {};
    }
}

export const UserStore = defineStore('user', {
    state: () => ({
        user: localUserData,
    }),
    getters: {
        data: (state) => state.user,
    },
    actions: {
        setUser(user) {
            this.user = user;
            localStorage.setItem('userData', JSON.stringify(user));
        }
    },
})
